import React from 'react';

import {Link} from 'react-router-dom';
import {Divider} from "antd";
import {THEME} from '../constant/theme';
import {t} from '../constant/i18n';



class Home extends React.Component {


    render() {


        return (
            <div>
                <h1>{t('home.backToSite')}</h1>
                <Divider />
                <a href={THEME.urls.site}>{THEME.urls.site}</a>
            </div>

        );
    }
}


export default Home;
